import { useHowWorkReferralModal } from '../model/useHowWorkReferralModal';
import s from './how-work-referral.module.scss'
import { Modal } from '@shared/ui/modal/modal'

export const HowWorkReferralModal = () => {

  const { isOpen, close } = useHowWorkReferralModal()

  return (
		<Modal {...{isOpen, close}}>
        <div className={s.wrapper}>
            <div className={s.headInfo}>
                <h1>Как работает реферальная система?</h1>
            </div>
            <div className={s.mainInfo}>
                <div className={s.info}> 
                  <span>
                   У каждого преподавателя есть уникальная реферальная ссылка, которой можно делиться с коллегами. Если новый преподаватель регистрируется на «Созвучно» по вашей ссылке и начинает проводить платные занятия, он становится вашим рефералом.
                  </span>
                  <span>
									 Количество активных рефералов определяет вашу комиссию на платформе. Чем больше активных преподавателей вы приглашаете на платформу, тем ниже ваша комиссия. Актуальные уровни вы можете посмотреть в личном кабинете.
									</span>
                </div>
            </div>
        </div>
		</Modal>
  );
};